import React, {useState, useEffect, useCallback} from 'react';
import ParameterKnob from 'components/knobs/ParameterKnob.js';
import Colors from 'components/Colors.js';
const colors = new Colors();

export default ({lastClicked, deleteSample, recording, onClickRecord}) => {
    const [gated, setGated] = useState(false);
    const [looping, setLooping] = useState(false);
    const [warp, setWarp] = useState(false);
    const [trackLength, setTrackLength] = useState(1);

    const onClickLoop = useCallback(() => {
        lastClicked.instrument.loopParameter.set(!looping);
        setLooping(!looping);
    }, [setLooping, looping, lastClicked]);

    const onClickGate = useCallback(() => {
        lastClicked.gated = !gated;
        setGated(!gated);
    }, [setGated, gated, lastClicked]);

    const onClickLength = useCallback(() => {
        let newTrackLength = trackLength * 2;
        if (newTrackLength === 8) {
            newTrackLength = 1;
        }
        lastClicked.pattern.changeLength(newTrackLength * 32);
        setTrackLength(newTrackLength);
    }, [setTrackLength, trackLength, lastClicked]);

    useEffect(() => {
        if (lastClicked) {
            setGated(lastClicked.gated);
            setLooping(lastClicked.instrument.loop);
            setWarp(lastClicked.isWarped());
            setTrackLength(lastClicked.length / 32);
        }
    }, [lastClicked, setGated, setLooping, setWarp, setTrackLength]);
    if (lastClicked === undefined) {
        return [];
    }

    let gateClass = "button-option";
    let loopClass = "button-option";
    let warpClass = "button-option";

    let color = colors.saturate(
        colors.getColorForHash(lastClicked.instrument.defaultSampler.sample.getId()), 3);

    let loopingStyle = {};
    let gatedStyle = {};
    let lengthStyle = {
        backgroundColor : color,
        color : 'black'
    };

    if (looping) {
        loopClass += " selected";
        loopingStyle.backgroundColor = color;
        loopingStyle.color = 'black';
    }


    if (gated) {
        gateClass += " selected";
        gatedStyle.backgroundColor = color;
        gatedStyle.color = 'black';
    }


    return (
        <div className="sample-options">
         <div className="name">
            {lastClicked.instrument.defaultSampler.sample.name}
          </div>
          <div className="buttons">
            <div
              onClick={onClickGate}
              style={gatedStyle}
              className={gateClass}>
              Gate
            </div>
            <div
              onClick={onClickLoop}
              style={loopingStyle}
              className={loopClass}>
              Loop
            </div>
            <div
              onClick={onClickLength}
              style={lengthStyle}
              className="button-option length-button">
              {trackLength} Bars
            </div>
            <div
              onClick={deleteSample}
              className="delete-button">x</div>
          </div>
          <div className="knobs">
            <ParameterKnob
              min={-40}
              max={0}
              color={color} parameter={lastClicked.volumeParameter}/>
            <ParameterKnob color={color} parameter={lastClicked.instrument.defaultSampler.transposeParameter}/>
          </div>
        </div>
    );
}
